var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-fluid",staticStyle:{"width":"100%","height":"100%","object-fit":"cover"},attrs:{"src":_vm.getIcon}})}
var staticRenderFns = []

export { render, staticRenderFns }